export const appMemberIcon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 9C9.66667 9 11 7.66667 11 6C11 4.33333 9.66667 3 8 3C6.33333 3 5 4.26667 5 5.93333C5 7.6 6.33333 9 8 9Z" fill="currentColor"/><rect x="2" y="11" width="12" height="3" rx="1.5" fill="currentColor"/></svg>`,
    name: 'member'
};